var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0222 0H99.9778C111.037 0 120 8.35368 120 18.6626V101.337C120 111.646 111.037 120 99.9778 120H20.0222C8.96338 120 0 111.646 0 101.337V18.6626C0 8.35368 8.96338 0 20.0222 0Z",
    fill: "#EFEFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02246 96.7332V53.0412C9.02246 43.6837 16.6343 36.0902 26.0301 36.0902H93.0674C102.456 36.0902 110.075 43.6767 110.075 53.0412V96.7332C110.075 106.091 102.463 113.684 93.0674 113.684H26.0301C16.6343 113.677 9.02246 106.091 9.02246 96.7332Z",
    fill: "#DC8060"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3078 102.168C75.0142 102.168 87.7468 89.4351 87.7468 73.7287C87.7468 58.0223 75.0142 45.2898 59.3078 45.2898C43.6014 45.2898 30.8689 58.0223 30.8689 73.7287C30.8689 89.4351 43.6014 102.168 59.3078 102.168Z",
    fill: "#FFF7E6",
    stroke: "#83C284",
    strokeWidth: 13.4096,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2282 27.0678C56.8917 27.0887 55.0148 28.8304 55.0378 30.9551C55.0838 35.0166 55.1221 39.085 55.1297 43.1464C55.1451 48.1413 55.1221 53.1363 55.1221 58.1312C55.1221 61.0711 55.1297 64.0109 55.1297 66.9507C55.1297 67.9818 55.1297 69.0128 55.1221 70.0508C55.1221 70.3434 55.1144 70.636 55.1068 70.9286C55.1068 71.0818 55.1068 71.2351 55.0914 71.3884C55.0914 71.4093 55.0991 71.3535 55.0991 71.3326C54.8616 73.5689 56.6542 75.5543 59.1133 75.7703C61.5724 75.9862 63.7633 74.3561 64.0008 72.1198C64.0697 71.458 64.0544 70.7753 64.0544 70.1135C64.0621 69.0546 64.0621 68.0027 64.0544 66.9438C64.0391 63.8855 64.0084 60.8342 63.9625 57.7759C63.8859 52.8785 63.7633 47.9811 63.679 43.0837C63.6024 39.0153 63.5565 34.9539 63.5028 30.8855C63.4722 28.7537 61.5647 27.0469 59.2282 27.0678Z",
    fill: "#83C284"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9473 48.2707C18.9473 46.0306 20.7673 44.2105 23.0074 44.2105C25.2475 44.2105 27.0676 46.0306 27.0676 48.2707C27.0676 50.5107 25.2475 52.3308 23.0074 52.3308C20.7673 52.3308 18.9473 50.5107 18.9473 48.2707Z",
    fill: "#F2BCA6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0591 33.6225C58.1002 33.0463 60.5609 16.5185 70.8482 10.8477C79.7041 5.97089 95.5757 4.95899 99.1505 8.12118C100.977 9.73741 95.8578 24.1781 85.7538 30.3689C75.6428 36.5598 62.0346 35.4074 59.0591 33.6225Z",
    fill: "#83C284"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7822 35.0406C75.6126 34.6901 81.1582 33.401 85.9225 30.4555C95.9652 24.2423 101.053 9.74974 99.2379 8.1277C97.6894 6.74454 93.8191 6.15712 89.2163 6.33976C89.3897 7.83188 89.3319 11.1521 87.0793 16.8585C83.3359 26.3475 75.2788 32.3147 70.7822 35.0406Z",
    fill: "#68B86B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2407 55.9399C16.2407 54.9416 16.8454 54.1353 17.5941 54.1353C18.3428 54.1353 18.9475 54.9416 18.9475 55.9399C18.9475 56.9381 18.3428 57.7444 17.5941 57.7444C16.8454 57.7444 16.2407 56.9381 16.2407 55.9399Z",
    fill: "#F2BCA6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4587 59.1016C23.4587 58.3563 24.0629 57.7444 24.8082 57.7444C25.5535 57.7444 26.1655 58.3485 26.1655 59.1016C26.1655 59.8469 25.5614 60.451 24.8082 60.451C24.0629 60.4589 23.4587 59.8548 23.4587 59.1016Z",
    fill: "#F2BCA6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5413 93.8346C96.5413 92.3362 97.7566 91.1278 99.248 91.1278C100.746 91.1278 101.955 92.3431 101.955 93.8346C101.955 95.333 100.74 96.5413 99.248 96.5413C97.7496 96.5413 96.5413 95.333 96.5413 93.8346Z",
    fill: "#F2BCA6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.5188 99.6992C87.5188 98.9496 88.1225 98.3459 88.8722 98.3459C89.6218 98.3459 90.2256 98.9496 90.2256 99.6992C90.2256 100.449 89.6218 101.053 88.8722 101.053C88.1291 101.053 87.5188 100.442 87.5188 99.6992Z",
    fill: "#F2BCA6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7368 104.211C94.7368 101.973 96.5519 100.15 98.797 100.15C101.042 100.15 102.857 101.965 102.857 104.211C102.857 106.456 101.042 108.271 98.797 108.271C96.5519 108.263 94.7368 106.448 94.7368 104.211Z",
    fill: "#F2BCA6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8431 32.9347C59.8032 32.332 56.2991 17.2996 46.1303 10.8241C35.9615 4.34861 21.7281 6.13569 18.6094 8.23812C16.528 9.63974 23.0386 25.6603 32.7939 31.8485C42.5492 38.0366 55.8506 34.8059 58.8431 32.9347Z",
    fill: "#83C284"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_329_1600",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 6,
    width: 41,
    height: 30
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8431 32.9347C59.8032 32.332 56.2991 17.2996 46.1303 10.8241C35.9615 4.34861 21.7281 6.13569 18.6094 8.23812C16.528 9.63974 23.0386 25.6603 32.7939 31.8485C42.5492 38.0366 55.8506 34.8059 58.8431 32.9347Z",
    fill: "#83C284"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_329_1600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1881 8.90393C47.1881 8.90393 51.4421 18.3228 48.3725 24.6932C45.296 31.0636 34.0549 34.2173 34.0549 34.2173C34.0549 34.2173 38.0285 36.3267 44.0906 36.8383C45.6464 36.9714 46.8798 37.0065 48.4076 37.0065C51.4281 37.0065 53.951 36.6841 53.951 36.6841C53.951 36.6841 55.1984 35.738 55.7731 34.89C58.9758 30.1596 57.2098 20.2641 57.2098 20.2641C57.2098 20.2641 55.5068 16.774 52.1709 13.0527C49.662 10.2705 47.1881 8.90393 47.1881 8.90393Z",
    fill: "#68B86B"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4341 15.4459C29.4341 13.4906 31.0179 11.9138 32.9662 11.9138C34.9214 11.9138 36.4983 13.4977 36.4983 15.4459C36.4983 17.4012 34.9144 18.978 32.9662 18.978C31.0179 18.978 29.4341 17.3942 29.4341 15.4459Z",
    fill: "#C9E3C9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7676 21.8163C34.7676 21.0804 35.3633 20.4847 36.0991 20.4847C36.835 20.4847 37.4307 21.0804 37.4307 21.8163C37.4307 22.5521 36.835 23.1478 36.0991 23.1478C35.3633 23.1478 34.7676 22.5521 34.7676 21.8163Z",
    fill: "#C9E3C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.fecba0053234981183bf70f0bbf8ece8.svg";
export { ForwardRef as ReactComponent };